import ssfRest from '../np-rest/ssfRest';

const restCreate = props => {
    const [SSFRest] = ssfRest(props);
    return [SSFRest]
}

export default restCreate;